module.exports = __webpack_public_path__ + "6b4fece54cc9cc6e75dd28879a4b2a60.webm";